'use strict';

import * as Props from '../Props';

const angular = require('angular');

const ToggleButtonProperties = {
    Basic: {
        'ControlType': 'ToggleButton',
        'Label': {
            name: 'label',
            selectedValue: 'Toggle Button',
            type: 'textbox',
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe',
        },
        'Field Name': Props.getFieldName('ToggleButton'),
        'Data Field Name': Props.getDataFieldName('ToggleButton'),
        'LabelOff': {
            name: 'labeloff',
            selectedValue: 'OFF',
            type: 'textbox',
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe',
        },
        'LabelOn': {
            name: 'labelon',
            selectedValue: 'ON',
            type: 'textbox',
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe',
        },
        'ValueOff': {
            name: 'value.off',
            selectedValue: 'Value Off',
            type: 'textbox',
            onChangeFunction: 'updateValueText'
        },
        'ValueOn': {
            name: 'value.on',
            selectedValue: 'Value On',
            type: 'textbox',
            onChangeFunction: 'updateValueText'
        },
        'Value': {
            name: 'value',
            selectedValue: false,
            type: 'checkbox',
            hidden: true
        },
        'DSName': {
            selectedValue: '',
            hidden: true
        },
        'Name': {
            selectedValue: 'Basic',
            hidden: true
        },
    },
    Display: {
        'Read-only': {
            name: 'read.only',
            selectedValue: false,
            type: 'checkbox'
        },
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        }
    },
    Style: angular.copy(Props.labelStyleObject),
    ControlStyle: angular.copy(Props.controlStyleObject),
    SwitchToggleStyle: {
        'style-group': {
            type: 'style-group',
            members: {
                'background-color-on': {
                    type: 'color-picker',
                    title: 'backgroundcoloron',
                    selectedValue: '#007bff',
                    icon: 'fa fa-paint-brush',
                    onChangeFunction: 'updateStyle',
                    name: 'backgroundcoloron'
                },
                'background-color-off': {
                    type: 'color-picker',
                    title: 'backgroundcoloroff',
                    selectedValue: '#cccccc',
                    icon: 'fa fa-paint-brush',
                    onChangeFunction: 'updateStyle',
                    name: 'backgroundcoloroff'
                },
            }
        },
        'Name': {
            selectedValue: 'switch.style',
            hidden: true
        }
    },
    Margin: angular.copy(Props.marginObject),
    Advance: {
        'Tooltip': {
            name: 'tooltip',
            type: 'textbox',
            selectedValue: ''
        },
        'Tabindex': {
            name: 'tabindex',
            selectedValue: '',
            type: 'number'
        },
        'Searchable': angular.copy(Props.Searchable),
        'Reportable': angular.copy(Props.Reportable),
        'customizable-column': angular.copy(Props.Customizable),
        'Name': {
            selectedValue: 'Advanced',
            hidden: true
        }
    },
    Events: {
        Name: angular.copy(Props.elementEventsObject).Name,
        load: angular.copy(Props.elementEventsObject).load,
        click: {
            name: 'onClick',
            type: 'event',
            selectedValue: '',
            xmlValue: '',
            onClickFunction: 'openCodeEditorDialog'
        },
    },
    Size: {
        'Height': {
            name: 'height',
            selectedValue: 25,
            type: 'number',
            min: 25,
            max: 50
        },
        'Width': {
            name: 'width',
            selectedValue: 50,
            type: 'number',
            min: 50,
            max: 100
        },
        'Name': {
            selectedValue: 'Size',
            hidden: true
        }
    }
};



export default ToggleButtonProperties;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Toggle_Button.ts